import customData from '../../../../custom-settings/CustomText.json'

export function LogoutPage() {
    let logoutText = customData.logout;
    return <span className="fs-3">{logoutText}</span>
}